import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/admin/entrance', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {path: '/store', component: () => import('@/views/rms/view.vue'), hidden: true},
  {path: '/appDetails', component: () => import('@/views/rms/AppDetails.vue'), hidden: true},
  {path: '/appDownload', component: () => import('@/views/rms/appDownload.vue'), hidden: true},

  /*{
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }*/
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'product', // 父路由的名称唯一
    meta: {title: '应用', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '应用列表', icon: 'product-list'}
      },
    ],
  },
  {
    path: '/pms/productAttr', // 修改路径以确保唯一性
    component: Layout,
    redirect: '/pms/productAttr/index',
    name: 'productAttr', // 父路由的名称唯一
    meta: {title: '应用', icon: 'product'},
    children: [
      {
        path: 'index',
        name: 'productAttr', // 子路由的名称唯一
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '应用图标', icon: 'product-attr'}
      },
    ],
  },
  {
    path: '/pms/productCate', // 修改路径以确保唯一性
    component: Layout,
    redirect: '/pms/productCate/index',
    name: 'productCate', // 父路由的名称唯一
    meta: {title: '应用', icon: 'product'},
    children: [
      {
        path: 'index',
        name: 'productCate', // 子路由的名称唯一
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '应用分类', icon: 'product-cate'}
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js